import { BreadcrumbItem } from '../components/Breadcrumbs/BreadcrumbContainer';

const generateGoogleBreadcrumbScript = (
  crumbs: BreadcrumbItem[],
  origin: string
) => {
  if (!crumbs || crumbs.length === 0) {
    return null;
  }
  const items = [];
  crumbs?.forEach((crumb, i) => {
    const item = {
      '@type': 'ListItem',
      position: i + 1,
      name: crumb.name,
      item: null,
    };
    if (crumb.url) {
      // Make sure the URL is absolute.
      item.item = crumb.url.toLowerCase().startsWith('http')
        ? crumb.url
        : origin + crumb.url;
    }
    items.push(item);
  });
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
};

export { generateGoogleBreadcrumbScript };
